import { Temporal } from "temporal-polyfill";
export class RTimeZone {
    static get browserTimezoneOffset() {
        return Temporal.Now.instant().toZonedDateTimeISO(Temporal.Now.timeZoneId())
            .offset;
    }
    static get restaurantTimezoneOffset() {
        const timeZone = Skubacz.configuration.time_zone;
        const now = Temporal.Now.instant();
        const zonedDateTime = now.toZonedDateTimeISO(timeZone);
        return zonedDateTime.offset;
    }
    static get isRestarantDifferentFromBrowserTimezone() {
        return this.browserTimezoneOffset !== this.restaurantTimezoneOffset;
    }
}
